import React, { useRef, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { Creature } from "@dndModels";

import DandDAPI from "@utilities/smart_api";

import DandDButtonBox from '@dndComponents/DandDButtonBoxSimple';

const api = DandDAPI.getInstance();

// Admin tool: rewrites every creature's light copy from its full version.
// The light copy stores things worked out from the creature's features (damage types dealt,
// attack and effect types), since it doesn't have the features themselves.
// Creatures saved before those were stored, or saved while they were stored wrong, need this.
export default function CreatureLightRefreshTool() {
  const [progress, setProgress] = useState<{ done: number, total: number, failed: string[] } | null>(null);
  const stopping = useRef(false);

  const running = !!progress && progress.done < progress.total;

  const refresh = async () => {
    stopping.current = false;
    const creatures = await api.getObjects({ data_type: "creature" }) as Creature[];
    const failed: string[] = [];
    setProgress({ done: 0, total: creatures.length, failed });
    for (let i = 0; i < creatures.length; ++i) {
      if (stopping.current) {
        setProgress({ done: creatures.length, total: creatures.length, failed: [...failed, `Stopped after ${i}`] });
        return;
      }
      const creature = creatures[i];
      try {
        await api.loadObject(creature);
        await api.upsertLight("creature", creature, true);
      } catch (ex) {
        console.error(ex);
        failed.push(creature.name);
      }
      setProgress({ done: i + 1, total: creatures.length, failed: [...failed] });
    }
  };

  return (
    <Grid container spacing={1} direction="row">
      <Grid size={12} className="header">
        Refresh Creature Light Data
      </Grid>
      <Grid size={12} className="small_label gray">
        Loads every creature in full and rewrites its light copy, so the damage types it deals
        (and its attack and effect types) can be filtered on without loading it.
        This takes a while with a lot of creatures.
      </Grid>
      <Grid size={6}>
        <DandDButtonBox
          name="Refresh All Creatures"
          disabled={running}
          onClick={refresh}
        />
      </Grid>
      <Grid size={6}>
        <DandDButtonBox
          name="Stop"
          disabled={!running}
          onClick={() => { stopping.current = true; }}
        />
      </Grid>
      { progress &&
        <Grid size={12}>
          { running ?
            `Refreshing ${progress.done} / ${progress.total}...` :
            `Refreshed ${progress.done - progress.failed.length} of ${progress.total}.${progress.failed.length > 0 ? ` Problems: ${progress.failed.join(", ")}` : ""}`
          }
        </Grid>
      }
    </Grid>
  );
}
